"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default2 = exports.default = {
  props: {
    /* 表单按钮 */
    btns: {
      type: Array,
      default: function _default() {
        return [];
      },
      validator: function validator(v) {
        if (Array.isArray(v)) {
          return Array;
        } else {
          // eslint-disable-next-line no-console
          console.error('props传入参数错误!!\n', "':btns=\"<Array>\"'\u53C2\u6570\u503C\u5FC5\u987B\u4E3A\u5BF9\u8C61");
        }
        return Array;
      }
    }
  },
  data: function data() {
    return {};
  }
};